import { render, staticRenderFns } from "./SectionDownArrow.vue?vue&type=template&id=4ee839d9&scoped=true&"
import script from "./SectionDownArrow.vue?vue&type=script&lang=js&"
export * from "./SectionDownArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee839d9",
  null
  
)

export default component.exports